import { useState, useEffect } from "react";
import {
    format,
    subMonths,
    addMonths,
    subYears,
    addYears,
    isEqual,
    getDaysInMonth,
    getDay,
    startOfWeek
} from "date-fns";
import ptBR from 'date-fns/locale/pt-BR';
import { MdCalendarToday } from "react-icons/md";
import Typography from "../Typography";
import { IoMdArrowDropleft, IoMdArrowDropright } from "react-icons/io";
import { InputBase } from "../Input/InputBase";
import CircularProgress from "../CircularProgress";

export default function Calendar({ className, label, selectedDate, setSelectedDate, loading }) {
    const DAYS = ["seg", "ter", "qua", "qui", "sex", "sab", "dom"];
    const [dayCount, setDayCount] = useState([]);
    const [blankDays, setBlankDays] = useState([]);
    const [showDatepicker, setShowDatepicker] = useState(false);
    const [datepickerHeaderDate, setDatepickerHeaderDate] = useState(new Date());
    const [type, setType] = useState("date");

    const decrement = () => {
        switch (type) {
            case "date":
                setDatepickerHeaderDate((prev) => subMonths(prev, 1));
                break;
            case "month":
                setDatepickerHeaderDate((prev) => subYears(prev, 1));
                break;
            case "year":
                setDatepickerHeaderDate((prev) => subMonths(prev, 1));
                break;
        }
        document.getElementById('calendario').focus();
    };

    const increment = () => {
        switch (type) {
            case "date":
                setDatepickerHeaderDate((prev) => addMonths(prev, 1));
                break;
            case "month":
                setDatepickerHeaderDate((prev) => addYears(prev, 1));
                break;
            case "year":
                setDatepickerHeaderDate((prev) => subMonths(prev, 1));
                break;
        }
        document.getElementById('calendario').focus();
    };

    const isToday = (date) => {
        return isEqual(
            format(new Date(datepickerHeaderDate.getFullYear(), datepickerHeaderDate.getMonth() - 1, date), "yyyy-MM-dd"),
            format(selectedDate, "yyyy-MM-dd")
        );
    }

    /* const isDataMinMax = (date) => {
        return isEqual(
            format(new Date(datepickerHeaderDate.getFullYear(), datepickerHeaderDate.getMonth() - 1, date), "yyyy-MM-dd"),
            format(selectedDate, "yyyy-MM-dd")
        );
    } */


    const setDateValue = (date) => () => {
        setSelectedDate(
            new Date(
                datepickerHeaderDate.getFullYear(),
                datepickerHeaderDate.getMonth(),
                date
            )
        );
        setShowDatepicker(false);
    };

    const getDayCount = (date) => {
        let daysInMonth = getDaysInMonth(date);

        let dayOfWeek = getDay(new Date(date.getFullYear(), date.getMonth(), 1)) - 1;
        let blankdaysArray = [];
        for (let i = 1; i <= (dayOfWeek == -1 ? 5 : dayOfWeek); i++) {
            blankdaysArray.push(i);
        }

        let daysArray = [];
        for (let i = 1; i <= daysInMonth; i++) {
            daysArray.push(i);
        }

        setBlankDays(blankdaysArray);
        setDayCount(daysArray);
    };

    /* const isSelectedMonth = (month) =>
        isEqual(
            new Date(selectedDate.getFullYear(), month, selectedDate.getDate()),
            selectedDate
        );

    const setMonthValue = (month) => () => {
        setDatepickerHeaderDate(
            new Date(
                datepickerHeaderDate.getFullYear(),
                month,
                datepickerHeaderDate.getDate()
            )
        );
        setType("date");
    }; */

    const toggleDatepicker = () => setShowDatepicker((prev) => !prev);

    //const showMonthPicker = () => setType("month");

    //const showYearPicker = () => setType("date");

    useEffect(() => {
        getDayCount(datepickerHeaderDate);
    }, [datepickerHeaderDate]);

    useEffect(() => {
        if (showDatepicker) document.getElementById('calendario').focus();
    }, [showDatepicker]);

    return (
        <div className={className} >
            <div className="relative">
                <div className="relative w-full" >
                    <InputBase
                        readOnly
                        type="text"
                        label={label}
                        value={format(selectedDate, "dd/MM/yyyy")}
                        onClick={toggleDatepicker}
                        componentInterno={<input type="hidden" name="date" />}
                        icon={<>
                            {loading && <div className="flex flex-row absolute right-2">
                                <CircularProgress className="m-8" />
                            </div>}
                            <MdCalendarToday className="w-5 h-5 relative text-text-tertiary" />
                        </>}
                    />
                </div>
                <div
                    id="calendario"
                    tabIndex="0"
                    onBlur={() => setShowDatepicker(false)}
                    className={`${!showDatepicker && "hidden"} bg-neutras-white mt-12 rounded-lg shadow-[0px_4px_25px_0px_rgba(0,0,0,0.25)] p-2 absolute top-0 left-0 z-50 w-[18.5em]`}
                >
                    <div className="flex justify-between items-center py-[0.62em] mb-[0.63em]">
                        <div
                            className="transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 ml-3 rounded-full"
                            onClick={decrement}
                        >
                            <IoMdArrowDropleft />
                        </div>

                        <Typography component="body-calendar-title"
                            //onClick={showMonthPicker}
                            className="flex p-1 uppercase cursor-pointer text-center "
                        >
                            <p >
                                {format(datepickerHeaderDate, "MMMM", { locale: ptBR })}
                            </p>
                            <p className="pl-2">
                                {format(datepickerHeaderDate, "yyyy")}
                            </p>
                        </Typography>

                        <div
                            type="button"
                            className="transition ease-in-out duration-100 inline-flex cursor-pointer hover:bg-gray-200 mr-3 rounded-full"
                            onClick={increment}
                        >
                            <IoMdArrowDropright />
                        </div>
                    </div>
                    <div className="flex flex-wrap">
                        {DAYS.map((day, i) => (
                            <Typography component="body-calendar"
                                key={i}
                                className="text-center justify-center w-[calc(2.5em+5px)] h-[calc(2.5em+5px)]">
                                {day}

                            </Typography>
                        ))}
                    </div>
                    <div className="flex flex-wrap">
                        {blankDays.map((_, i) => (
                            <div key={i}
                                className="w-10 h-10"
                            ></div>
                        ))}
                        {dayCount.map((d, i) => (
                            <Typography component="body-calendar"
                                key={i}
                                onClick={setDateValue(d)}

                                className={`cursor-pointer text-center transition ease-in-out duration-100 w-[calc(2.5em+5px)] h-[calc(2.5em+5px)] justify-center 
                                                    ${isToday(d)
                                        ? "bg-calendar text-neutras-white"
                                        : "hover:text-neutras-white hover:bg-calendar"
                                    }`}
                            >
                                {d}
                            </Typography>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}
